import { api, qs } from '../client'
import type { Hashtag, Page, Post, SearchType, TimelineKind, Typeahead, User } from '../types'
import type { MessageKey } from '@/i18n'

export const searchApi = {
  /** 只有 posts 走游标分页；users / hashtags 按匹配质量排序，只有一页 */
  posts: (q: string, cursor?: string, limit = 20, kind?: TimelineKind) =>
    api.get<Page<Post>>(`/search${qs({ q, type: 'posts', cursor, limit, kind })}`),

  users: (q: string, limit = 20) =>
    api.get<Page<User>>(`/search${qs({ q, type: 'users', limit })}`),

  hashtags: (q: string, limit = 20) =>
    api.get<Page<Hashtag>>(`/search${qs({ q, type: 'hashtags', limit })}`),

  typeahead: (q: string) => api.get<Typeahead>(`/search/typeahead${qs({ q })}`),
}

export const searchTypeLabels: Record<SearchType, MessageKey> = {
  posts: 'searchTab.posts',
  users: 'searchTab.users',
  hashtags: 'searchTab.hashtags',
}
